$(document).ready(function() {
  $(document).on('change', '.brand-funnel-graph-select', function() {
    const timeline = $(this).val();
    const hs_brand_ids = $(this).attr('hs_brand_ids').split(' ');
    const parent = $(this).closest('.brand-funnel-graph-container');
    const hs_brand_ids_params = hs_brand_ids.map(hs_brand_id => `hs_brand_ids[]=${hs_brand_id}`).join('&');

    $.get(`/components/brands/funnel?timeline=${timeline}&${hs_brand_ids_params}`).done(function(html) {
      parent.find('.brands-funnel-component').replaceWith(html);
    });

    const scoreboardDropDown = $('.brand-scoreboard-select');
    if (scoreboardDropDown.val() !== timeline) scoreboardDropDown.val(timeline).trigger('change');
  });
});